import { DateInputLocalized } from '@components'

import { FormItem, Text } from '@billy/design-system'
import { t } from 'i18next'
import { ReactElement, ReactNode, useMemo } from 'react'

import { usePaymentModal } from './../../../paymentReconciliationModal/contexts'

export const PaymentDateInput = (): ReactElement => {
  const { paymentDate, setPaymentDate } = usePaymentModal()

  const dateInputError = useMemo((): ReactNode => {
    return (
      paymentDate === undefined && (
        <Text colorVariant="danger">{t('bill.payment_reconcile.payment_date_required')}</Text>
      )
    )
  }, [paymentDate])

  return (
    <FormItem label={t('bill.payment_reconcile.payment_date')} error={dateInputError}>
      <DateInputLocalized
        allowClear={true}
        value={paymentDate ? new Date(paymentDate) : undefined}
        onChange={setPaymentDate}
      />
    </FormItem>
  )
}
